import { ApplicationStore } from '../states'

export const updateIsRefresh: (state: ApplicationStore, payload: boolean) => ApplicationStore = (state, payload) => {
  return {
    ...state,
    isRefresh: payload,
  }
}

export const removeIsRefresh: (state: ApplicationStore) => ApplicationStore = (state) => {
  const newState: ApplicationStore = JSON.parse(JSON.stringify(state))

  delete newState.isRefresh
  return {
    ...newState,
  }
}
